import { useStaticQuery, graphql } from 'gatsby'

export const useFeaturedServicesQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query FeaturedServicesQuery {
      wpPage(title: { eq: "Home" }) {
        featuredServices {
          featuredServices {
            title
            subtitle
            text
            accordions {
              icon {
                localFile {
                  publicURL
                }
              }
              label
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP)
                  }
                }
              }
              altText
              title
              text
              link {
                url
                title
              }
            }
          }
        }
      }
    }
  `)
  return wpPage.featuredServices.featuredServices
}
